import { BaseClientService } from '@/services/base-client-service';


export class ClientService extends BaseClientService {


}
